import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";
import { hideLoader, showLoader } from "../loader/loaderSlice";

// 🔹 Fetch Categories
export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async (language = "en", { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      const res = await getApiRequest(
        `${END_POINTS.GET_CATEGORIES}?lang=${language}`
      );
      if (res?.success) return res?.data?.categories;
      return rejectWithValue(res?.message || "Failed to load categories");
    } catch (err) {
      return rejectWithValue(err.message);
    } finally {
      dispatch(hideLoader());
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
